// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d7739fbb","453":"8a16c133"}[chunkId] + ".chunk.js";
};